import styled from "styled-components";
import { tokens } from "../../../.././../public/tokens";
const { colors, typography, globals, effects } = tokens;

// Container styles
export const Container = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;

    @media screen and (max-width: 480px) {
        width: 100%;
    }
`;

export const MainLayout = styled.div`
    display: grid;
    grid-template-columns: ${props => props.$hasSidebar ? "5fr 2fr" : "1fr"};
    gap: 26px;
    min-width: 100%;
    @media screen and (max-width: 1300px){
      grid-template-columns: ${props => props.$hasSidebar ? "5fr 3fr" : "1fr"};
      }
    @media screen and (max-width: 1210px) {
        grid-template-columns: 1fr;
        gap: 16px;
    }
`;

export const MainContent = styled.div`
    min-width: 0;
    max-width: 100%;
    display: flex;
    flex-direction: column;
    gap: 12px;
    overflow: hidden;

    @media screen and (max-width: 1210px) {
        order: 2;
    }
`;
export const ModuleWrapper = styled.div`
    min-width: 0;
    max-width: 100%;
    gap: 10px;
    overflow: hidden;
`

export const Sidebar = styled.div`
    align-self: start;
    position: sticky;
    top: 20px;
      @media screen and (max-width: 1210px) {
        height: fit-content;
        position: static!important;
        max-width: 100%;
    }
`;

// Section styles
export const SectionTitle = styled.div`
    font-size: ${typography.fontSize['base-16px']};
    font-weight: ${typography.fontWeights.bold};
    color: ${colors.neutral.grey[700]};
    margin-bottom: 4px;
    display: flex;
    align-items: center;
`;

export const SectionDescription = styled.div`
    font-size: ${typography.fontSize['lg-14px']};
    color: ${colors.text.secondary};
    margin-bottom: 16px;
    line-height: ${typography.lineHeights[130]};
`;

// Year accordion styles
export const YearGroup = styled.div`
    margin-bottom: 10px;
    box-shadow: ${effects.effects.shadow.default};
    border-radius: ${globals["border-radius"]};
    overflow: hidden;
`;

export const YearAccordionHeader = styled.div`
    background-color: ${colors.theme['topbar-color']};
    border-radius: ${props => props.$collapsed ? globals["border-radius"] : `${globals["border-radius"]} ${globals["border-radius"]} 0 0`};
    padding: 10px 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    height: 40px;
    box-sizing: border-box;
`;

export const YearAccordionTitle = styled.span`
    color: ${colors.neutral.white};
    font-size: ${typography.fontSize['lg-14px']};
    font-weight: ${typography.fontWeights.bold};
`;

export const YearAccordionRight = styled.div`
    display: flex;
    align-items: center;
    gap: 15px;
    color: ${colors.neutral.white};
    font-size: ${typography.fontSize['lg-14px']};
`;

export const CompletedText = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

// Module row styles
export const ModuleRow = styled.div`
        background-color: ${props =>
        props.$muted
            ? colors.neutral.grey['100']
            : props.$isExpanded
                ? colors.neutral.grey['100']
            : colors.neutral.white};
    border: 1px solid ${colors.surfaces["border-divider"]};
    border-top: ${props => props.$isFirst ? `1px solid ${colors.surfaces["border-divider"]}` : "none"};
    border-radius: ${props => props.$isLast ? `0 0 ${globals["border-radius"]} ${globals["border-radius"]}` : "0"};
    overflow: hidden;
    padding: 10px 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 5px;
    min-height: 40px;
    box-sizing: border-box;
    cursor: ${props => props.$hasDropdown ? "pointer" : "default"};
    transition: background-color 0.2s ease;

    ${props => {
        if (!props.$hasDropdown) return '';
        const hoverColor = props.$isExpanded ? colors.neutral.grey['100']  : colors.neutral.grey['200'];
        return `
            &:hover {
                background-color: ${hoverColor};
            }
        `;
    }};

    @media screen and (max-width: 480px) {
        flex-wrap: wrap;
        flex-direction: column;
        align-items: stretch;
       gap: 5px;
    }
`;

export const ModuleLeft = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 5px;
  
    @media screen and (max-width: 480px) {
        width: 100%;
        justify-content: space-between;
        display: flex;
        flex-wrap: wrap;
        gap: 6px;
    }
`;

export const ModuleIcon = styled.div`
    width: 18px;
    display: flex;
    justify-content: center;
    flex-shrink: 0;
`;

export const ModuleName = styled.span`
    font-size: ${typography.fontSize['lg-14px']}    ;
    font-weight: ${typography.fontWeights.bold};
    color: ${colors.text.link};
    text-box-edge: cap alphabetic;
    text-box-trim: trim-both;
    white-space: nowrap;
   text-wrap: pretty;


    flex: 1;
    min-width: 0;

    @media screen and (max-width: 480px) {
        font-size: ${typography.fontSize['md-12px']};
        white-space: normal;
        word-break: break-word;
            max-width: 150px;
    }
`;

export const ModuleRight = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    flex-shrink: 1;

    @media screen and (max-width: 480px) {
        width: 100%;
        justify-content: space-between;
        flex-wrap: nowrap;
        gap: 5px;
        width: 100%;
        margin-top: 8px;
    }
`;

export const ModuleSemester = styled.div`
    display: flex;
    align-items: center;
    gap: 5px;
    font-size: ${typography.fontSize['lg-14px']};
    color: ${colors.text.secondary};
    text-box-edge: cap alphabetic;
    text-box-trim: trim-both;
    white-space: nowrap;
        @media screen and (max-width: 480px) {
   white-space: wrap;
   font-size: ${typography.fontSize['md-12px']};
    }
`;

export const ModulePrice = styled.span`
    font-size: ${typography.fontSize['lg-14px']};
    font-weight: ${typography.fontWeights.bold};
    color: ${props => props.$isCredit ? colors.states.success.default : colors.text.primary};
    min-width: 80px;
    text-align: right;
    text-box-edge: cap alphabetic;
    text-box-trim: trim-both;
    white-space: nowrap;
    visibility: ${props => props.$hidden ? "hidden" : "visible"};

    @media screen and (max-width: 480px) {
    margin-left: 10px;   
        text-align: left;
    }
`;

export const ModuleActions = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
  

    @media screen and (max-width: 480px) {
        gap: 6px;
    }
`;

export const ActionButton = styled.button`
    margin-left: 1em;
    min-width: 30px;
    width: 30px;
    height: 30px;
    max-height: 30px;
    border-radius: 50%;
    padding: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    font-size: 14px;
    box-shadow: 0px 1.5px 2px 0px rgb(0 0 0 / 30%) !important;
    border: none !important;
    cursor: ${props => props.$disabled ? "not-allowed" : "pointer"};
    background-color: ${props => {
        if (props.$disabled) return "#cfd3d9";
        if (props.$variant === "delete") return "#dc3545";
        if (props.$variant === "add") return "var(--button-color)";
        return "#467fcf";
    }};

    color: ${tokens.colors.neutral.white};
    
    &:hover {
        background-color: ${tokens.colors.theme["button-hover-color"]};
    }
    
    i {
        margin-right: 0;
    }
`;

// Spacer used when an action button should be visually present but inactive (e.g. non-removable NOT ELIGIBLE modules)
export const ActionButtonSpacer = styled.div`
    margin-left: 1em;
    min-width: 30px;
    width: 30px;
    height: 30px;
    max-height: 30px;
    border-radius: 50%;
    padding: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    visibility: hidden;
`;

export const ChevronButton = styled.button`
    background: none;
    border: none;
    cursor: pointer;
    font-size: ${tokens.typography.fontSize["2xl-20px"]};
    color: ${tokens.colors.theme["button-color"]};
    padding: 0 4px;
`;

// Module expanded styles
export const ModuleExpanded = styled.div`
    background-color: ${colors.surfaces["container-background"]};
    border: 1px solid ${tokens.colors.surfaces["border-divider"]};
    border-top: none;
    padding: 12px ;

`;

export const ModuleDescription = styled.div`
    font-size: ${typography.fontSize['lg-14px']};
    text-box-edge: cap alphabetic;
    text-box-trim: trim-both;
    color: ${colors.text.secondary};
    text-wrap: pretty;
    line-height: ${typography.lineHeights[110]};
 
`;

// Prerequisites styles
export const PrerequisitesTitle = styled.div`
    font-size: ${typography.fontSize['lg-14px']};
    line-height: ${typography.lineHeights[100]};
    font-weight: ${typography.fontWeights.bold};
    color: ${colors.text.primary};
    margin: 12px 0 5px 0;
`;

export const PrerequisitesContainer = styled.div`
    border: 1px solid ${tokens.colors.surfaces["border-divider"]};
    border-radius: ${globals["border-radius"]};
    overflow: hidden;
`;
export const PrerequisiteWrapper = styled.div`

`

export const PrerequisiteRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 5px 15px;
    background-color: ${props => props.$isFailed ? tokens.colors.neutral.grey[100] : tokens.colors.neutral.white};
    border-bottom: ${props => props.$isLast ? "none" : `1px solid ${tokens.colors.surfaces["border-divider"]}`};
    min-height: 45px;
       @media screen and (max-width: 768px) {
        gap: 6px;
    }
`;

export const PrerequisiteLeft = styled.div`
    display: flex;
    align-items: center;
    gap: 5px;
    flex: 1;
`;

export const PrerequisiteName = styled.span`
    font-size: ${tokens.typography.fontSize['lg-14px']};
    font-weight: ${tokens.typography.fontWeights.bold};
    color: ${tokens.colors.text.link};
`;

export const PrerequisiteRight = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
       @media screen and (max-width: 768px) {
        gap: 6px;
    }
`;

// Submission container
export const SubmissionContainer = styled.div`
    display: flex;
    overflow: hidden;
    flex-direction: column;
    flex-wrap: nowrap;
    height: fit-content;
    align-items: flex-start;
    justify-content: space-between;
`;

export const SectionContainer = styled.div`
    display: flex;
    overflow: hidden;
    flex-direction: column;
    flex-wrap: nowrap;
    height: fit-content;
    align-items: flex-start;
    justify-content: space-between;
`;
